module.exports = __webpack_public_path__ + "media/images/riders/small/SERGIO_GUTIERREZ_MANTECON-1f3cdada1da597f5b14f5528580c94f6.png";